<template>
  <div>
    <div class="b-portlet">
      <div class="b-portlet-body">
        <div class="columns">
          <div
            class="column"
            v-if="
              ((!currentUser.companyId || role.company || role.companyDefaultProcess) &&
                !role.processWithPoint) ||
                role.admin
            "
          >
            <b-menu>
              <b-menu-list :label="$t('title.onlineInternalAuditProcesses')">
                <b-menu-item
                  icon-pack="fas"
                  icon="caret-right"
                  v-for="process in defaultProcesses"
                  :key="process.id"
                  @click="selectProcess(process)"
                  :disabled="process.disabled"
                >
                  <template slot="label">
                    <b-tooltip
                      v-if="process.description && process.description !== ''"
                      class="control"
                      :label="process.description"
                      position="is-right"
                      multilined
                      expanded
                    >
                      {{ process.name }}
                      <InfoIcon style="margin-left:10px;" />
                    </b-tooltip>
                    <span v-else>{{ process.name }}</span>
                  </template>
                </b-menu-item>
              </b-menu-list>
            </b-menu>
          </div>
          <div class="column" v-if="companyProcesses.length > 0 || companyProcessGroups.length > 0">
            <b-menu v-if="(role.admin || !role.processWithPoint) && companyProcesses.length > 0">
              <b-menu-list :label="`${companyLabel} ${$t('title.specialInternalAuditProcesses')}`">
                <b-menu-item
                  icon-pack="fas"
                  icon="caret-right"
                  v-for="process in companyProcesses"
                  :key="process.id"
                  @click="selectProcess(process)"
                >
                  <template slot="label">
                    <b-tooltip
                      v-if="process.description && process.description !== ''"
                      class="control"
                      :label="process.description"
                      position="is-right"
                      multilined
                      expanded
                    >
                      {{ process.name }}
                      <InfoIcon style="margin-left:10px;" />
                    </b-tooltip>
                    <span v-else>{{ process.name }}</span>
                  </template>
                </b-menu-item>
              </b-menu-list>
            </b-menu>
            <b-menu
              v-if="role.processWithPoint && companyProcessGroups.length > 0"
              :activable="false"
              :style="{
                marginTop:
                  (role.admin || !role.processWithPoint) && companyProcesses.length > 0
                    ? '20px'
                    : '0'
              }"
            >
              <b-menu-list :label="`${companyLabel} ${$t('title.specialInternalAuditProcesses')}`">
                <b-menu-item
                  icon-pack="fas"
                  icon="angle-down"
                  v-for="companyProcessGroup in companyProcessGroups"
                  :expanded="false"
                  :key="companyProcessGroup.parentProcessGroup.id"
                >
                  <template #label="props">
                    &nbsp;{{ companyProcessGroup.parentProcessGroup.name }}
                    <b-icon
                      class="is-pulled-right"
                      :icon="props.expanded ? 'menu-up' : 'menu-down'"
                    ></b-icon>
                  </template>
                  <b-menu-item
                    v-for="processGroupItem in companyProcessGroup.processGroups"
                    :key="processGroupItem.processGroup.id"
                    icon-pack="fas"
                    icon="caret-right"
                    :label="processGroupItem.processGroup.name"
                    @click="selectProcess(processGroupItem)"
                  ></b-menu-item>
                </b-menu-item>
              </b-menu-list>
            </b-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from '../../_api/api.service'
import { APP_ID } from '../../_helpers/config'

export default {
  data () {
    return {
      defaultProcesses: [],
      companyProcesses: [],
      companyProcessGroups: []
    }
  },
  computed: {
    ...mapGetters(['role', 'currentUser']),
    companyLabel () {
      if (!this.currentUser.parentCompany && !this.currentUser.company) {
        return this.$t('title.company')
      }
      return this.currentUser.parentCompanyId
        ? this.currentUser.parentCompany
        : this.currentUser.company
    }
  },
  mounted () {
    this.getProcesses()
  },
  methods: {
    getProcesses () {
      ApiService.query('/process').then(data => {
        if (this.role.limited) {
          ApiService.query(`/process/lookup?appId=${APP_ID}`).then(lookupData => {
            const defaultProcesses = []
            const lookupDefaultProcesses = lookupData.filter(p => p.parentCompanyId == null)
            lookupDefaultProcesses.forEach(lookupDefaultProcess => {
              const matchedProcesses = data.filter(d => d.id === lookupDefaultProcess.id)
              if (matchedProcesses.length > 0) {
                defaultProcesses.push(matchedProcesses[0])
              } else {
                // eslint-disable-next-line no-param-reassign
                lookupDefaultProcess.disabled = true
                defaultProcesses.push(lookupDefaultProcess)
              }
            })
            this.defaultProcesses = defaultProcesses
          })
        } else {
          this.defaultProcesses = data.filter(p => p.parentCompanyId === null)
        }
        this.companyProcesses = data.filter(
          p => p.parentCompanyId !== null && p.processGroupId === null
        )

        const companyProcessesWithGroups = data.filter(
          p => p.parentCompanyId !== null && p.processGroupId !== null
        )
        if (companyProcessesWithGroups.length > 0) {
          this.companyProcessGroups = companyProcessesWithGroups.reduce((acc, cur) => {
            const parentGroup = acc.find(
              p => p.parentProcessGroup.id === cur.processGroup.parentProcessGroupId
            )
            if (parentGroup) {
              const processGroup = parentGroup.processGroups.find(
                p => p.processGroup.id === cur.processGroupId
              )
              if (processGroup) {
                processGroup.processes.push(cur)
              } else {
                parentGroup.processGroups.push({
                  isProcessGroup: true,
                  processGroup: cur.processGroup,
                  processes: [cur]
                })
              }
            } else {
              acc.push({
                parentProcessGroup: cur.processGroup.parentProcessGroup,
                processGroups: [
                  {
                    isProcessGroup: true,
                    processGroup: cur.processGroup,
                    processes: [cur]
                  }
                ]
              })
            }
            return acc
          }, [])
        }
      })
    },
    selectProcess (process) {
      if (!process.disabled) {
        this.$emit('selectProcess', process)
      }
    }
  }
}
</script>
